import { render, staticRenderFns } from "./ProductFoodBest.vue?vue&type=template&id=0fd8062b&scoped=true&"
import script from "./ProductFoodBest.vue?vue&type=script&lang=js&"
export * from "./ProductFoodBest.vue?vue&type=script&lang=js&"
import style0 from "./ProductFoodBest.vue?vue&type=style&index=0&id=0fd8062b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8062b",
  null
  
)

export default component.exports